import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-[#06220F] border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Louisiana Ducks logo" className="h-16 w-16 object-contain" data-testid="footer-logo" />
              <span className="font-display text-3xl uppercase text-white">Louisiana Ducks</span>
            </div>
          </div>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-link-${link.label.toLowerCase()}`}
                    className="text-sm uppercase tracking-widest text-gray-300 hover:text-[#FEE123] transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/donate" data-testid="footer-link-donate" className="text-sm uppercase tracking-widest text-[#FEE123] font-bold hover:text-[#FFEA61] transition-colors duration-200">
                  Donate
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-[0.3em] text-[#FEE123]">Where We Play</h3>
            <p className="mt-5 text-sm text-gray-300 leading-relaxed" data-testid="footer-location">
              Based in St. Charles Parish, Louisiana.
              <br />
              Serving families across the New Orleans metro area.
            </p>
            <p className="mt-4 text-xs uppercase tracking-widest text-gray-400" data-testid="footer-nonprofit-note">
              Louisiana Ducks is a non-profit youth sports organization.
            </p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs uppercase tracking-widest text-gray-500" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Louisiana Ducks. All rights reserved.
          </p>
          <p className="font-display text-lg uppercase text-[#FEE123]/70">Education &bull; Character &bull; Community</p>
        </div>
      </div>
    </footer>
  );
}
